module.exports = __webpack_public_path__ + "img/yeosu_gallery4.4099293b.jpg";